import {baseRequestService} from "../base.ts";
import {Event} from '../../types/domain.ts';

export const eventsEventIdGet = (eventId: string) => baseRequestService<Event>({
    url: `/events/${eventId}`,
    method: 'GET'
})